import { render, staticRenderFns } from "./ProductListScreen.vue?vue&type=template&id=a1711804&"
import script from "./ProductListScreen.vue?vue&type=script&lang=ts&"
export * from "./ProductListScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports